export default __webpack_public_path__ + "static/media/Thank-you-letters.5aa34150.pdf";